import cx from 'classnames'
import { useTrackChangesToggle } from 'common/Prose/Toolbar/hooks/useTrackChangesToggle'
import { VisualSwitch } from 'components/VisualSwitch/VisualSwitch'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { Button } from 'components/Button'
import { ReactComponent as TrackChangesIcon } from 'assets/icons/trackChanges24.svg'
import Styles from './TrackChangesButtons.module.scss'

export const TrackChangesButton: React.FC<React.PropsWithChildren<{}>> = observer(function TrackChangesButton() {
  const { active, handleClick, disabled } = useTrackChangesToggle()

  return (
    <Tooltip label="Version Control Mode prevents you from using tracked changes. Use a layer instead" hide={!disabled}>
      <Button
        size="md"
        isDisabled={disabled}
        onPress={handleClick}
        variant="tertiary"
        frontIcon={TrackChangesIcon}
        iconClassName={cx(Styles.icon, Styles.doubleClassOverride)}
        className={cx(Styles.button, Styles.doubleClassOverride)}
      >
        <span className={Styles.label}>
          Track changes
          <VisualSwitch active={active} />
        </span>
      </Button>
    </Tooltip>
  )
})
